import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldOff, Users, LifeBuoy, Megaphone } from 'lucide-react';
import { useAuth } from '../AuthContext';

// Shown when a role opens a page it can't use (direct URL).
export const NoPermission = () => (
  <div className="p-10 flex justify-center" data-testid="no-permission">
    <div className="max-w-md w-full bg-white border border-slate-200 rounded-2xl p-8 text-center shadow-sm">
      <div className="mx-auto w-12 h-12 rounded-full bg-rose-50 flex items-center justify-center"><ShieldOff size={22} className="text-rose-600" /></div>
      <h2 className="mt-4 text-lg font-bold text-slate-900" data-testid="no-permission-title">You don't have permission to access this page</h2>
      <p className="mt-1 text-sm text-slate-500">Ask your clinic owner if you need access.</p>
      <Link to="/patients" data-testid="no-permission-home" className="mt-5 inline-flex px-4 py-2 rounded-lg bg-slate-900 hover:bg-slate-800 text-white text-sm font-semibold transition-colors">Go to Dashboard</Link>
    </div>
  </div>
);

// Marketing role home — no patient or revenue data.
export const MarketingHome = () => {
  const { user } = useAuth();
  const tiles = [
    { to: '/settings/referral-doctors', Icon: Users, t: 'Referral Doctors', d: 'View the doctors who refer patients to your clinic', testid: 'mkt-tile-referral-doctors' },
    { to: '/care', Icon: LifeBuoy, t: 'AUDINEXA Care', d: 'Help articles and support tickets', testid: 'mkt-tile-care' },
  ];
  return (
    <div className="p-6 max-w-4xl" data-testid="marketing-home">
      <h1 className="text-2xl font-bold text-slate-900">Welcome, {user?.name || 'there'}</h1>
      <p className="text-sm text-slate-500 mt-1">Your marketing workspace.</p>
      <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
        {tiles.map(({ to, Icon, t, d, testid }) => (
          <Link key={to} to={to} data-testid={testid}
            className="bg-white border border-slate-200 rounded-xl p-5 hover:border-indigo-300 hover:shadow-sm transition-[border-color,box-shadow]">
            <Icon size={20} className="text-indigo-600" />
            <div className="mt-2 font-semibold text-slate-900">{t}</div>
            <div className="text-sm text-slate-500">{d}</div>
          </Link>
        ))}
      </div>
      <div className="mt-4 rounded-xl border border-dashed border-slate-300 bg-slate-50 p-5 flex items-start gap-3" data-testid="mkt-coming-soon">
        <Megaphone size={18} className="text-slate-500 mt-0.5" />
        <div className="text-sm text-slate-600"><b>Smart Marketing and lead lists</b> will appear here as soon as they're available.</div>
      </div>
    </div>
  );
};

const MARKETING_PATHS = ['/care', '/settings/referral-doctors', '/settings/profile'];

// Marketing users only reach their home + allowed pages; everything else shows NoPermission.
export const marketingContent = (pathname, children) => {
  if (pathname === '/patients' || pathname === '/patients/') return <MarketingHome />;
  return MARKETING_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`)) ? children : <NoPermission />;
};
